/**
 * Le texte d'un refus de l'API, d'après le code qu'elle place dans son message
 * (`ALREADY_SUBSCRIBED`, `SUBSCRIPTION_RUNNING`…). Un refus inconnu, ou une
 * panne, reçoit le texte par défaut.
 */
export function errorCodeKey(error: unknown, keys: Record<string, string>, fallback: string): string {
  const text = error instanceof Error ? error.message : String(error)
  const code = Object.keys(keys).find(candidate => text.includes(candidate))
  return code ? keys[code]! : fallback
}
